<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center row>
        <v-dialog
                :item="item"
                :value="value"
                @input="close()"
                v-model="show"
                width="800">
            <v-card>
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Packet anlegen</v-list-item-title>
                        <v-list-item-subtitle>
                            Geben sie einen Packetnamen an.
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider class="mt-2"></v-divider>

                <v-text-field
                        class="ps-3 pe-3"
                        label="Ordnername"
                        v-model="packageName"
                ></v-text-field>

                <v-layout>
                    <v-flex>
                        <v-text-field
                                clearable
                                class="ps-3 pe-3"
                                label="Sortierungsposition"
                                outline
                                required
                                type="number"
                                min=0
                                v-model="order_index"
                        ></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-select
                                v-if="state.servesSelect"
                                class="ps-3 pe-3"
                                :items="packages"
                                item-text="name"
                                @change="getPackageId"
                                label="Paket für Ausgangsstruktur"
                                required
                                v-model="selectedPackage"
                        ></v-select>
                    </v-flex>
                </v-layout>

                <v-card-actions class="pe-3">
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="show = false"
                            color="primary">Abbrechen
                    </v-btn>

                    <v-btn
                            v-if="state.servesSelect"
                            @click="addPackage"
                            color="primary">Hinzufügen
                    </v-btn>

                    <v-btn
                            v-if="!state.servesSelect"
                            @click="editPackage"
                            color="primary">Übernehmen
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import PackageDialogStore from "@/ts/stores/PackageDialogStore";

    export default {
        name: "PackageDialog",

        data() {
            return {
                packageName: '',
                order_index: undefined,
                selectedPackage: undefined,
                selectedPackageId: null,
                state: PackageDialogStore.state,
                show: false
            }
        },
        props: {
            value: Boolean,
            packages: {},
            item: {}
        },
        watch: {
            state: {
                handler() {
                    this.show = this.state.dialogVisible;
                    this.packageName = this.state.package.name;
                    this.order_index = this.state.order_index;
                },
                deep: true
            },
            show(val) {
                if (!val) {
                    this.close()
                }
            }
        },
        methods: {
            close() {
                PackageDialogStore.dismiss()
            },
            addPackage() {
                this.$emit('add', {
                    'template_packet_id': this.selectedPackageId,
                    'name': this.packageName,
                    'order_index': Number(this.order_index)
                });
                this.close()
            },
            editPackage() {
                this.$emit('edit', {
                    'id': PackageDialogStore.state.package.id,
                    'name': this.packageName,
                    'order_index': Number(this.order_index)
                });
                this.close()
            },
            getPackageId(packageItem) {
                this.selectedPackage = packageItem;
                this.selectedPackageId = this.packages.find(it => it.name === packageItem).id
            }
        }
    }
</script>
